<template>
  <div class="card">
    <div class="card-content">
      <div class="media-content">
        <p class="title is-4">{{ parsed.Contact }}</p>
        <p class="subtitle is-6">{{ parsed.PhoneNumber }}</p>
      </div>
    </div>
    <ul class="im-messages">
      <li v-for="(m, i) in parsed.Messages" :key="i" :class="`im-message direction_${m.Direction} mb-4`">
        <div class="pre-message"></div>
        <div class="message-content">
          {{ m.Message }}<br/>
          <small v-if="m.Timestamp">{{ m.Timestamp }}</small>
        </div>
        <div class="post-message"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: String,
  },
  computed: {
    parsed() {
      return JSON.parse(this.content || "{}");
    },
  },
};
</script>

<style lang="scss">
.im-messages {
  padding-bottom: 10px;
  .im-message {
    margin: 10px;
    display: flex;
    border-radius: 10px;
    .message-content {
      border-radius: 10px;
      padding: 10px;
      color: #000;
    }
    &.direction_System {
      background-color: #ccc;
      .message-content {
        flex-grow: 1;
        text-align: center;
      }
    }
    &.direction_Sent {
      .pre-message { flex-grow: 1; }
      .message-content {
        background-color: rgb(123, 216, 123);
      }
    }
    &.direction_Received {
      .message-content {
        background-color: #f5f5f5;
      }
      .post-message { flex-grow: 1; }
    }
  }
}
</style>